import { create } from 'zustand';

interface CompleteVulModalStore {
  isOpen: boolean;
  vulId?: number;
  planSlug: string;
  onCompleteVulOpen: (slug: string) => void;
  onCompleteVulClose: () => void;
}

export const useEditPlanOnMapModalStore = create<CompleteVulModalStore>(set => ({
  isOpen: false,
  vulId: 0,
  planSlug: '',
  onCompleteVulClose: () => set({ isOpen: false, vulId: 0, planSlug: '' }),
  onCompleteVulOpen: (planSlug: string) => set({ isOpen: true, planSlug }),
}));
